<template>
    <div class="dislike-btn-container" @click="toggleActivity">
     <div class="circle-bg"></div>
     <svg id="Component_8_1" :class='"Component_8_1" + content.objectid' data-name="Component 8 – 1"
       xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" >
 
       <g filter="url(#filter0_b_792_2497)">
         <circle cx="24" cy="24" r="24" fill="white" fill-opacity="0.3" />
       </g>
     
       <path
         d="M16.1017 14.2864C15.9549 14.2864 15.8081 14.2864 15.6613 14.2784C14.8232 14.2116 14.2627 14.7481 14.2733 15.5889C14.3054 17.9565 14.3321 20.324 14.3614 22.6889C14.3774 23.8794 14.6871 24.181 15.8802 24.181C16.9051 24.181 17.9274 24.173 18.9524 24.1917C19.0805 24.1917 19.2327 24.3251 19.3261 24.4372C19.6651 24.8403 19.9854 25.2567 20.311 25.6731C21.6723 27.416 22.7293 29.3138 23.3085 31.4598C23.458 32.0177 23.5808 32.5835 23.7169 33.1467C23.7916 33.4564 24.1199 33.7206 24.4376 33.7286C26.0391 33.7713 27.3923 32.5435 27.2722 30.8913C27.1815 29.6368 26.7651 28.4063 26.4928 27.1651C26.4928 27.1651 26.4928 27.1598 26.4928 27.1571C26.4127 26.8021 26.717 26.4818 27.0774 26.5405C27.2162 26.5619 27.355 26.5779 27.4911 26.5806C28.6522 26.5993 29.8213 26.6713 30.969 26.5432C32.1541 26.4098 32.72 25.5129 32.9549 24.4025C33.3579 22.4967 33.3312 20.5963 32.7894 18.7279C32.4851 17.6762 32.1808 16.5952 31.6737 15.637C31.0358 14.4358 29.7652 13.8913 28.5187 13.9073C27.2802 13.9234 26.0417 13.9714 24.8032 14.0328C23.5647 14.0969 22.3262 14.1743 21.0904 14.2463C20.7007 14.2704 20.311 14.2917 19.9213 14.3157L18.8617 14.273M20.0628 15.8612C20.0628 15.5889 20.2763 15.3647 20.5486 15.3487C21.0023 15.3247 21.4214 15.3033 21.8431 15.29C24.0078 15.2286 26.1752 15.0818 28.3345 15.1538C29.6825 15.1992 30.993 15.7758 30.7982 17.5454C30.7822 17.6816 30.9263 17.8657 31.0438 17.9778C31.6523 18.5597 31.8178 19.243 31.6096 20.0518C31.5669 20.2226 31.5803 20.4628 31.671 20.6043C32.1648 21.3704 32.1968 22.107 31.6924 22.8891C31.5776 23.0653 31.5642 23.3909 31.6417 23.5964C32.0153 24.6161 31.687 25.3581 30.614 25.4008C29.2741 25.4542 27.9182 25.3528 26.5836 25.1873C25.5079 25.0538 25.1476 25.278 25.2383 26.4231C25.3371 27.6803 25.7588 28.9081 26.023 30.1519C26.1805 30.8966 26.2286 31.644 25.5479 32.1805C25.3531 32.3326 25.1849 32.4661 24.9527 32.346C24.7498 32.2419 24.603 31.4919 24.563 31.3557C23.8717 28.8894 22.7506 26.6313 21.0904 24.6828C20.3697 23.8393 19.9907 23.0119 20.0388 21.8722C20.1215 19.881 20.0735 17.8817 20.0654 15.8558L20.0628 15.8612ZM18.7389 15.7678V22.4887C18.7389 22.7717 18.5093 22.9985 18.2291 22.9985H15.7788C15.4958 22.9985 15.2689 22.769 15.2689 22.4887V15.7678C15.2689 15.4848 15.4985 15.2579 15.7788 15.2579H18.2291C18.512 15.2579 18.7389 15.4875 18.7389 15.7678Z"
         :class='"Path_18" + content.objectid' :fill="disliked ? thumbSelectedColor : thumbColor" />
       <defs>
         <filter id="filter0_b_792_2497" x="-6" y="-6" width="60" height="60" filterUnits="userSpaceOnUse"
           color-interpolation-filters="sRGB">
           <feFlood flood-opacity="0" result="BackgroundImageFix" />
           <feGaussianBlur in="BackgroundImageFix" stdDeviation="3" />
           <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_792_2497" />
           <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_792_2497" result="shape" />
         </filter>
       </defs>
     </svg>
   </div>
 </template>
 
 <script>
 import { eventBus } from "@/eventBus";
 import { mapGetters } from "vuex";
 import { getDatabase, ref, onValue } from "firebase/database";
 import FirebaseActions from "@/mixins/FirebaseActions";
 import { _projectName } from "@/provider-config.js";
 import Redirection from "@/mixins/redirection.js";
 
 export default {
   props: {
     content: {
       type: Object,
     },
     dislikeFireCount: {
       type: Number,
     },
     height: {
       type: String,
     },
     width: {
       type: String,
     },
   },
   data() {
     return {
       disliked: false,
       dislikedColor: null,
       thumbSelectedColor: "#ef6537",
       noColor: "#161616",
       dislikeBlackColor: "black",
       thumbColor: "#ffffff",
       currentState: null,
       dislikeCount: 0,
       contentDislikeCount: null,
       likeCountDisplay: null,
       applyColor: "clr-red",
       defaultColor: "dislike",
     };
   },
   watch: {
     contentDislikeCount(val) {
       this.$emit("dislikeCount", val);
     },
     dislikeFireCount(val) {
       console.log("content from parent", val);
     },
     content(val) {
       this.fetchButtonState();
       this.getContentDislikeCount();
       this.getContentLikeCount();
     },
     subscriberid(val) {
       if (val) {
         this.fetchButtonState();
       }
     },
   },
   computed: {
     ...mapGetters(["subscriberid", "profileid"]),
   },
   mounted() {
     this.getContentDislikeCount();
     this.getContentLikeCount();
     eventBus.$on("updateDislikeLikeStatus", () => {
       console.log("logged In from dislike no subscriber Button");
     });
   },
   created() {
     this.fetchButtonState();
     this.dislikedColor = "#010001";
   },
   methods: {
     fetchButtonState() {
       if (!this.content) return;

       const content = this.content;
       const db = getDatabase();
       let path = `/subscriber/${this.subscriberid}/${this.profileid}/content/`;

       if ("seriesid" in content && content.seriesid) {
         path += `${content.objectid}/episodes/${content.objectid}`;
       } else {
         path += `${content.objectid}`;
       }

       const contentRef = ref(db, path);

       onValue(contentRef, (snapshot) => {
         const response = snapshot.val();

         if (response && response.likestatus === "DISLIKE") {
           this.disliked = true;
           this.action = "REMOVE";
           this.currentState = "";
         } else if (response && response.likestatus === "LIKE") {
           this.action = "ADD";
           this.disliked = false;
           console.log("current state from dislike", response.likestatus);
           this.currentState = "LIKE";
         } else {
           this.disliked = false;
           this.action = "ADD";
           this.currentState = "";
         }
       }, (error) => {
         console.error("Error fetching button state:", error);
       });
     },
     getContentDislikeCount() {
       let payload = {
         objectid: this.content.objectid,
         type: "dislike",
       };
       this.fetchLikeDislikeCount(payload).then((result) => {
         if (result) {
           this.contentDislikeCount = result;
         } else {
           this.contentDislikeCount = 0;
         }
         this.$emit("dislikeCount", this.contentDislikeCount);
       });
     },
     getContentLikeCount() {
       let payload = {
         objectid: this.content.objectid,
         type: "like",
       };
       this.fetchLikeDislikeCount(payload).then((result) => {
         if (result) {
           this.likeCountDisplay = result;
         } else {
           this.likeCountDisplay = 0;
         }
       });
     },
     toggleActivity() {
       if (this.subscriberid) {
         if (this.action === "ADD" && this.currentState === "") {
           this.updateLikeDislikeToFire(this.content, "DISLIKE");
           this.contentDislikeCount = this.contentDislikeCount + 1;
           this.$emit("dislikeCount", this.contentDislikeCount);
         } else if (this.action === "ADD" && this.currentState === "LIKE") {
           console.log("likeCountDisplay", this.likeCountDisplay);
           this.updateContentCount(
             this.content,
             this.contentDislikeCount,
             "DISLIKE",
             this.likeCountDisplay
           );
           this.updateLikeDislikeToFire(this.content, "DISLIKE");
           this.contentDislikeCount = this.contentDislikeCount + 1;
           this.$emit("dislikeCount", this.contentDislikeCount);
           this.$emit("likeCount", this.likeCountDisplay);
         } else if (this.action === "REMOVE") {
           this.updateContentCount(
             this.content,
             this.contentDislikeCount,
             "REMOVEDISLIKE"
           );
           this.updateLikeDislikeToFire(this.content, "NONE");
           this.contentDislikeCount =
             this.contentDislikeCount > 0 ? this.contentDislikeCount - 1 : 0;
           this.$emit("dislikeCount", this.contentDislikeCount);
         }
       } else {
         let localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
         localDisplayLang = localDisplayLang == 'eng' ? 'en' : localDisplayLang;
         this.redirectToLogin(localDisplayLang);
       }
     },
   },
   mixins: [FirebaseActions, Redirection],
 };
 </script>
 
 <style>
 .dislike-btn-container {
   display: inline-block;
   position: relative;
   cursor: pointer;
 }
 
 .circle-bg {
   position: absolute;
   top: 0;
   left: 0;
   width: 48px;
   height: 48px;
   background-color: transparent;
   border-radius: 50%;
   transition: background-color 0.3s;
   z-index: -1;
   pointer-events: none;
 }
 
 .dislike-btn-container:hover .circle-bg {
   /* background-color: #fff; */
 }
 
 .dislike-btn-container:hover svg path {
   fill: #ef6537 !important;
 }
 </style>